import { render, staticRenderFns } from "./SelfBilling.vue?vue&type=template&id=30954bfa"
import script from "./SelfBilling.vue?vue&type=script&lang=js"
export * from "./SelfBilling.vue?vue&type=script&lang=js"
import style0 from "./SelfBilling.vue?vue&type=style&index=0&id=30954bfa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports